/*** IMPORTS FROM imports-loader ***/
var define = false;

/**
 * [getColorForPercentage description]
 * @param  {[type]} pct    [description]
 * @param  {[type]} colors [description]
 * @return {[type]}        [description]
 */
export function getColorForPercentage(pct, colors) {
	let i;

	for (i = 1; i < colors.length - 1; i++) {
		if (pct < colors[i].pct) {
			break;
		}
	}

	const LOWER = colors[i - 1];
	const UPPER = colors[i];
	const RANGE_PCT = (pct - LOWER.pct) / (UPPER.pct - LOWER.pct);
	const PCT_LOWER = 1 - RANGE_PCT;
	const PCT_UPPER = RANGE_PCT;
	const COLOR = {
			r: Math.floor(LOWER.color.r * PCT_LOWER + UPPER.color.r * PCT_UPPER),
			g: Math.floor(LOWER.color.g * PCT_LOWER + UPPER.color.g * PCT_UPPER),
			b: Math.floor(LOWER.color.b * PCT_LOWER + UPPER.color.b * PCT_UPPER)
		};

	return `rgb(${ [COLOR.r, COLOR.g, COLOR.b].join(',') })`;
}
